import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import $ from "jquery";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class CheckStock extends Component{
    constructor(props) {
        super(props);
        this.state = {
            mobileNumber: '',
            tableView: false,
            _notificationSystem: null,
            stock_response: [],
            loading:true
        }

    }

    handleSearch(showView, e){
        this.setState({
            tableView:showView,
        })
        if(showView === true){
            console.log(this.state.mobileNumber);
            this.showStocks();
        }
    }
    updateInput(e){
      const pattern = /^[0-9\b]+$/;
      console.log(pattern.test(e.target.value));
      if (e.target.value === '' || pattern.test(e.target.value)) {
        this.setState({
            mobileNumber:e.target.value,
        });
      }
    }
    showStocks(){
      const token = localStorage.usertoken;
      let warehouse_id = '';
      if(token != null) {
          const decoded = jwt_decode(token);
          warehouse_id = decoded.warehouse_id
      }
      if ($.fn.DataTable.isDataTable('#sroStocksTable')) {
          $('#sroStocksTable').DataTable().destroy();
      }
      axios.get(config.get('API_URL')+'/inventory/sro-stocks?user_id='+warehouse_id + '&mobile_number='+this.state.mobileNumber,{
        headers: {
            Authorization: ` ${localStorage.usertoken}`,
            SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
        this.setState({
            stock_response: response.data
        });
        $('#sroStocksTable').DataTable({
            "oLanguage": {
                "sEmptyTable": "There are no stocks available"
            }
        });
        this.setState({
            loading: false
        })
      });
    }
    render() {
        let stocks_data = this.state.stock_response.map((value, index) => {
          return (
              <tr key={index + 1}>
                  <td>{index + 1}</td>
                  <td>{value.Facility_Name__r.Name}</td>
                  <td>{value.Name}</td>
                  <td>{value.SKU__r.Name}</td>
                  <td>{value.SKU_Description__c}</td>
                  <td>{value.Current_Stock__c}</td>
                  <td>{value.Ordered_Quantity__c}</td>
                  <td>{value.Demand__c}</td>
                  <td>{value.Lost_Count__c}</td>
              </tr>
          )
        });

        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="">
                            {this.state.tableView === false?
                                <React.Fragment>
                                    <div className="row">
                                       <div className="col-md-3">
                                          <input type="text"  maxLength="10" className="form-control left_text" name="mobile" placeholder="Mobile number" value={this.state.mobileNumber} onChange={this.updateInput.bind(this)}/>
                                       </div>
                                      </div>
                                      <div className="gap_ver"></div>
                                      <div className="row">
                                       <div className="col-md-3">
                                            <button type="button" className="btn btn-primary" onClick={this.handleSearch.bind(this, true)}>Search</button>
                                       </div>
                                    </div>
                                </React.Fragment>
                            : null }
                            {this.state.tableView === true?
                                <React.Fragment>
                                    <div className="col-md-3 back-arrow-div">
                                        <a href="#" onClick={this.handleSearch.bind(this, false)}><i className="fa fa-angle-left" aria-hidden="true"></i></a>
                                    </div>
                                    <div className="content">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="">
                                                  <div className="header">
                                                      <p className="category"></p>
                                                  </div>
                                                </div>

                                                    <div className='sweet-loading'>
                                                        <BeatLoader
                                                            css={override}
                                                            sizeUnit={"px"}
                                                            size={20}
                                                            color={'#123abc'}
                                                            loading={this.state.loading}
                                                        />
                                                    </div>
                                                    <div className="content-tdetails-table table-full-width table-responsive">
                                                        <table className="table table-striped table-hover" id="sroStocksTable">
                                                            <thead>
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th>Facility name</th>
                                                                <th>Stock id</th>
                                                                <th>ISKU</th>
                                                                <th>ISKU description</th>
                                                                <th>Current stock</th>
                                                                <th>Ordered quantity</th>
                                                                <th>Current demand</th>
                                                                <th>Lost count</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                                {stocks_data}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                <div className="footer">
                                                    <div className="stats"><i></i></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                                : null }

                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default CheckStock
